import { useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { Stack, TopBarDefaultHeader } from "@bps/fluent-ui";
import { OpsReportDisplay } from "@components/OpsReportDisplay";
import { QueryStateIndicator } from "@components/QueryStateIndicator";
import { SectionTitle } from "@components/SectionTitle";
import { useOpsReportInstance } from "@libs/api/gateways/plt-reports-ops/plt-reports-ops-gateway.hooks";

export interface EmeddedFMReportProps {}

export const EmeddedFMReport = () => {
  const { reportName } = useParams<{
    reportName: string;
  }>();

  const instanceQuery = useOpsReportInstance(reportName);
  const navigate = useNavigate();

  const backToReports = useCallback(() => {
    navigate("/system/plt/fm-reports");
  }, [navigate]);

  return (
    <>
      <Stack horizontal>
        <TopBarDefaultHeader
          backButtonOnClick={backToReports}
          heading="Back to reports"
        />
        <SectionTitle>{reportName}</SectionTitle>
      </Stack>

      <QueryStateIndicator {...instanceQuery}>
        {instance => (
          <OpsReportDisplay embedConfig={instance} navContentPane={true} />
        )}
      </QueryStateIndicator>
    </>
  );
};
